import { render, staticRenderFns } from "./ClientJbbfMessageAfterAction.vue?vue&type=template&id=0d2d8b62&scoped=true&"
import script from "./ClientJbbfMessageAfterAction.vue?vue&type=script&lang=js&"
export * from "./ClientJbbfMessageAfterAction.vue?vue&type=script&lang=js&"
import style0 from "./ClientJbbfMessageAfterAction.vue?vue&type=style&index=0&id=0d2d8b62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d8b62",
  null
  
)

export default component.exports